module.exports = __webpack_public_path__ + "static/media/24-8.a7a395d1.mp3";